module.exports = __webpack_public_path__ + "static/media/bread.ff950f8a.png";